import { Component } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { Device } from '@capacitor/device';
import { Preferences } from '@capacitor/preferences';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone:false
})
export class AppComponent {
  constructor(private swUpdate: SwUpdate, private messageService: MessageService,private translate: TranslateService,
  ) {
    localStorage.setItem('theme', 'light');
    this.loadLanguage();
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe(event => {
        if (event.type === 'VERSION_READY') {
          this.showUpdateNotification();
        }
      });
    }
  }
  showUpdateNotification() {
    this.messageService.add({
      severity: 'info',
      summary: 'New Update Available',
      detail: 'Click to refresh',
      life: 5000,
      sticky: true
    });
    // Listen for user click
    setTimeout(() => {
      window.location.reload();
    }, 5000);
  }
   // Load the saved language (if any) from preferences or localStorage
   async loadLanguage(): Promise<void> {
    const info = await Device.getInfo();
    if (info.platform === 'ios') {
      // For iOS, get the language from Capacitor Preferences
      const res = await Preferences.get({ key: 'language' });
      if (res.value) {
        this.translate.use(res.value);
      } else {
        this.translate.use('fr'); 
      }
    } else {
      // For Web, get the language from localStorage
      const savedLanguage = localStorage.getItem('language');
      if (savedLanguage) {
        this.translate.use(savedLanguage);
      } else {
        this.translate.use('fr'); // Default to English
      }
    }
  }
}
